import { render, staticRenderFns } from "./EChartWrapper.vue?vue&type=template&id=3636554b&scoped=true"
import script from "./EChartWrapper.vue?vue&type=script&lang=js"
export * from "./EChartWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636554b",
  null
  
)

export default component.exports